import styled from 'styled-components'

export { AddButton, TableContainer, Table, Tr, Td, Th } from '../Conduit/styles'

export const SegmentBox = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surfaceElevated};
  border-radius: 8px;
  padding: 14px 16px 6px;
  margin-bottom: 14px;

  .segment-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    strong {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  }

  .segment-actions {
    display: flex;
    gap: 6px;

    button {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.textPrimary};

      svg {
        height: 20px;
        width: 20px;
      }

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }
  }
`

export const StatusTag = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #fff;
  background: ${({ $ok, theme }) => ($ok ? theme.colors.success : theme.colors.danger)};
`

export const Hint = styled.p`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 4px 0 10px;
`
